import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalInterface {
  siteTitle?: string | null;
}

const initialState: GlobalInterface = {
  siteTitle: null,
};

const global = createSlice({
  name: "global",
  initialState,
  reducers: {
    setSiteTitle: (state, action: PayloadAction<string>) => {
      state.siteTitle = action.payload;
    },
  },
});

export const { setSiteTitle } = global.actions;
export default global.reducer;
